import apiClient from "@/shared/api/apiClient2";
import {
  getApplicationDocuments,
  getApplicationParticipants,
  addApplicationParticipant,
  updateApplicationParticipant,
  deleteApplicationParticipant,
} from "@/entities/application";

export { getAvailableActions } from "./availableActions";

const enc = encodeURIComponent;

function failure(label, e) {
  console.error(`[transaction/api] ${label}`, e);
  return {
    success: false,
    error: e?.response?.data || e?.message || String(e),
  };
}

export const getParticipantNotarialList = async (params) => {
  try {
    const { data } = await apiClient.get("/participants/", { params });
    return data;
  } catch (e) {
    return failure("getParticipantNotarialList", e);
  }
};

export const getNotarialItem = async (id) => {
  try {
    const { data } = await apiClient.get(
      `/participants-cabinet/transactions/${enc(id)}/`
    );
    return data;
  } catch (e) {
    return failure("getNotarialItem", e);
  }
};

export const getTransactionLinks = async (tx_id) => {
  try {
    const { data } = await apiClient.get(
      `/participants-cabinet/transactions/${enc(tx_id)}/links`
    );
    return data;
  } catch (e) {
    return failure("getTransactionLinks", e);
  }
};

export const getCabinetAttorneys = async (params) => {
  try {
    const { data } = await apiClient.get("/participants-cabinet/attorneys", {
      params,
    });
    return data;
  } catch (e) {
    return failure("getCabinetAttorneys", e);
  }
};

export const createCabinetTransactionLink = async (tx_id, body) => {
  try {
    const { data } = await apiClient.post(
      `/participants-cabinet/transactions/${enc(tx_id)}/links`,
      body
    );
    return data;
  } catch (e) {
    return failure("createCabinetTransactionLink", e);
  }
};

export const removeCabinetTransactionLink = async (tx_id, link_id) => {
  try {
    const { data } = await apiClient.delete(
      `/participants-cabinet/transactions/${enc(tx_id)}/links/${enc(link_id)}`
    );
    return data;
  } catch (e) {
    return failure("removeCabinetTransactionLink", e);
  }
};

export const getAiCheckResult = async (tx_id, config) => {
  try {
    const { data } = await apiClient.get(
      `/participants-cabinet/transactions/${enc(tx_id)}/documents`,
      config
    );
    return data;
  } catch (e) {
    if (e?.code === "ERR_CANCELED" || e?.name === "CanceledError") return null;
    return failure("getAiCheckResult", e);
  }
};

export const triggerAiCheck = async (tx_id) => {
  try {
    const { data } = await apiClient.post(`/documents/${enc(tx_id)}/ai-check`);
    return data;
  } catch (e) {
    return failure("triggerAiCheck", e);
  }
};

// ===== Aliases — единый источник истины в @/entities/application =====
// Совместимость: внешние потребители импортируют эти имена из @/entities/transaction.

export const getDocumentListNotarial = getApplicationDocuments;
export const getParticipantListNotarial = getApplicationParticipants;
export const addParticipantToNotary = addApplicationParticipant;
export const updateParticipantNotarial = updateApplicationParticipant;
export const removeParticipantNotarial = deleteApplicationParticipant;
